import { ShieldAlert } from 'lucide-react';

export function Forbidden() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <ShieldAlert className="h-12 w-12 text-red-500 mb-4" />
      <h1 className="text-xl font-bold text-white mb-2">Access denied</h1>
      <p className="text-dark-400 text-sm max-w-sm">
        Your account doesn't have permission to perform this action, or the request was blocked
        for security reasons (origin/CSRF check).
      </p>
    </div>
  );
}
